export default "__VITE_ASSET__BBbEG6ST__"